import { createContext, useContext } from 'react';

export const RootStoreContext = createContext(null);

export const useStore = () => {
  const context = useContext(RootStoreContext);
  if (context === null) throw Error('Error');

  return context;
};
